import { render, staticRenderFns } from "./PXEAdd.vue?vue&type=template&id=b676ddba"
import script from "./PXEAdd.vue?vue&type=script&lang=js"
export * from "./PXEAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports